export default __webpack_public_path__ + "static/media/A0004.4571be0c.png";